import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { Mainloader } from "./components/Loaders/MainLoader/Mainloader";
import { Provider } from 'react-redux';
import { store } from "./app/store";

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const RootApp = () => {
  return (
    <React.StrictMode>
      <Suspense fallback={<Mainloader />}>
        <Router>
          <ScrollToTop />
          <Provider store={store}>
            <App />
          </Provider>
        </Router>
      </Suspense>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<RootApp />);
reportWebVitals();
